import {
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class StopEmailCycleRPC implements
  LeoRPC<StopEmailCycleRPC.Request, StopEmailCycleRPC.Response, StopEmailCycleRPC.Errors.Errors>
{
  abstract execute(
    request: StopEmailCycleRPC.Request
  ): Promise<LeoRPCResult<StopEmailCycleRPC.Response, StopEmailCycleRPC.Errors.Errors>>;
}

export namespace StopEmailCycleRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    scheduleId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isStopEmailCycleRPCRequest: boolean = true;
  
    readonly scheduleId: LeoUUID;
  
  
    constructor(
    scheduleId: LeoUUID
    ) {
      this.scheduleId = scheduleId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const scheduleId = getLeoUuid(dto, "scheduleId", InvalidRequestScheduleIdError);
      return new Request(
        scheduleId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          scheduleId: this.scheduleId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `StopEmailCycleRPC(scheduleId='${this.scheduleId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `StopEmailCycleRPC.Response()`;
  };

  export enum RPCError {
    InvalidScheduleId = "INVALID_SCHEDULE_ID",
    ProjectAlreadyArchived = "PROJECT_ALREADY_ARCHIVED",
    ScheduleNotInProgress = "SCHEDULE_NOT_IN_PROGRESS"
  }

  export namespace Errors {
    
    export interface InvalidScheduleIdDTO {
      code: string;
    }
    
    export class InvalidScheduleId extends LeoRPCError<RPCError> {
      readonly isInvalidScheduleId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidScheduleId;
        super(code);
      }
    
    
      toDTO(): InvalidScheduleIdDTO {
        const dto: InvalidScheduleIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidScheduleId.prototype.toString = function toString(): string {
      return `StopEmailCycleRPC.INVALID_SCHEDULE_ID()`;
    };
    
    
    export interface ProjectAlreadyArchivedDTO {
      code: string;
    }
    
    export class ProjectAlreadyArchived extends LeoRPCError<RPCError> {
      readonly isProjectAlreadyArchived: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.ProjectAlreadyArchived;
        super(code);
      }
    
    
      toDTO(): ProjectAlreadyArchivedDTO {
        const dto: ProjectAlreadyArchivedDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    ProjectAlreadyArchived.prototype.toString = function toString(): string {
      return `StopEmailCycleRPC.PROJECT_ALREADY_ARCHIVED()`;
    };
    
    
    export interface ScheduleNotInProgressDTO {
      code: string;
    }
    
    export class ScheduleNotInProgress extends LeoRPCError<RPCError> {
      readonly isScheduleNotInProgress: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.ScheduleNotInProgress;
        super(code);
      }
    
    
      toDTO(): ScheduleNotInProgressDTO {
        const dto: ScheduleNotInProgressDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    ScheduleNotInProgress.prototype.toString = function toString(): string {
      return `StopEmailCycleRPC.SCHEDULE_NOT_IN_PROGRESS()`;
    };
    

    export type Errors = InvalidScheduleId | ProjectAlreadyArchived | ScheduleNotInProgress;
    export type ErrorsDTO = InvalidScheduleIdDTO | ProjectAlreadyArchivedDTO | ScheduleNotInProgressDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidScheduleId:
          return new InvalidScheduleId();
        case RPCError.ProjectAlreadyArchived:
          return new ProjectAlreadyArchived();
        case RPCError.ScheduleNotInProgress:
          return new ScheduleNotInProgress();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestScheduleIdError extends StopEmailCycleRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestScheduleIdError";
  }
}


export class InvalidResponseInvalidScheduleIdError extends StopEmailCycleRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidScheduleIdError";
  }
}

export class InvalidResponseProjectAlreadyArchivedError extends StopEmailCycleRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseProjectAlreadyArchivedError";
  }
}

export class InvalidResponseScheduleNotInProgressError extends StopEmailCycleRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseScheduleNotInProgressError";
  }
}

